
import LottieAnimation from "@/components/LottieAnimationsComponent.vue";
import { PropType } from "vue";
import { PatientPortalMedicationMarketplaceRx } from "@/interfaces/PatientPortalMedicationMarketplaceRx";
import swal from "sweetalert";
import Sidebar from "primevue/sidebar";
import { MarketplaceMedicationDetailsViewModel } from "@/interfaces/MarketplaceMedicationDetailsViewModel";
import { FamilyPlanManagerViewModel } from "@/interfaces/FamilyPlanManagerViewModel";

export default {
  name: "pharmacy-medication-cards",
  props: {
    rxData: {
      type: Object,
      required: true,
    },
    selectedMeds: {
      type: Array,
      required: true,
    },
    familyPlanMembers: {
      type: Array as PropType<FamilyPlanManagerViewModel[]>,
      required: false,
      default: () => null,
    },
  },
  components: {
    LottieAnimation,
    Sidebar,
  },

  data() {
    return {
      showRxDetails: false,
      medicationDetails: {} as MarketplaceMedicationDetailsViewModel,
    };
  },
  computed: {
    formattedPrice(): string {
      return this.rxData.programPrice != null ? this.rxData.programPrice.toFixed(2) : "N/A";
    },
    isChecked() {
      return this.selectedMeds.some((med) => med.drugDisplayName === this.rxData.drugDisplayName);
    },
    associatedUser() {
      if (!this.familyPlanMembers || !Array.isArray(this.familyPlanMembers)) return null;

      return this.familyPlanMembers.find((member) => member.associatedUserID === this.rxData.userID) || null;
    },
  },

  methods: {
    toggleSelection(event: Event) {
      this.$emit("toggle-medication", { medication: this.rxData, selected: event.target.checked });
    },

    Track(rxData: PatientPortalMedicationMarketplaceRx) {
      swal("Warning", "You are about to leave our site and navigate to a shipping carrier site.", "warning").then(() => {
        window.open(rxData.trackingString.replace("{0}", rxData.trackingNumber), "_blank");
      });
    },
    convertToTitleCase(string: any) {
      return string
        .toLowerCase()
        .split(" ")
        .map(function (word: any) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    },

    async fetchDetails() {
      try {
        const associatedUserID = this.associatedUser ? this.associatedUser.associatedUserID : null;

        const response = await this.$store.dispatch("GetMedicationDetails", {
          rxID: this.rxData.rxID,
          associatedUserID: associatedUserID,
        });

        if (!response || !response.success) {
          swal("Error", "Error loading cart. Please try again.");
          return;
        }
        if (response && response.data) {
          this.medicationDetails = response.data;
          this.showRxDetails = true;
        }
      } catch (error) {
        swal("Error", "Error loading details. Please try again.");
      }
    },

    hideSidebar() {
      this.showRxDetails = false;
    },
  },
};
